import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	inputLabel: {
		id: 'jql-editor.ui.input-label',
		defaultMessage: 'JQL query',
		description:
			'Label for the input where users can type a JQL query. This text is not visible and is only read by screen readers.',
	},
});
